import { createContext, useState } from "react";

const LanguageContext = createContext(
    {
        language : cleanLang(navigator.language || navigator.languages[0]),
        setLanguage: () => {}
    }
);

function cleanLang(lang) {
    return lang.split('-').pop().toUpperCase();
}

export function LanguageContextProvider ({children}){
    const [language,setLanguage] = useState(cleanLang(navigator.language || navigator.languages[0]));

    const LanguageCtxValue = {
        language : language,
        setLanguage : setLanguage,
    }

    return (
        <LanguageContext.Provider value = {LanguageCtxValue}>
            {children}
        </LanguageContext.Provider>
    )
}

export default LanguageContext;